import { Link, type LinkComponentProps } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

interface NavLinkProps extends Omit<LinkComponentProps<'a'>, 'to'> {
  to: string
}

/** Nav destinations are data-driven (src/config/nav.ts), so `to` is loosely typed here. */
function NavLink({ to, className, ...props }: NavLinkProps) {
  return (
    <Link
      to={to as never}
      className={cn(
        'text-muted-foreground hover:text-foreground text-sm font-medium transition-colors',
        className,
      )}
      activeProps={{ className: 'text-foreground' }}
      activeOptions={{ exact: to === '/' }}
      {...props}
    />
  )
}

export { NavLink }
